import { useEffect, useState } from "react";
import { useBlocker } from "react-router-dom";

interface Props {
  shouldBlock: boolean;
}

interface Blocker {
  state: "blocked" | "proceeding" | "unblocked";
  proceed: () => void;
  reset: () => void;
}

export const useUnsavedChangesPrompt = ({ shouldBlock }: Props) => {
  const blocker = useBlocker(shouldBlock);

  const [showModal, setShowModal] = useState<boolean>(false);
  const [lastBlocker, setLastBlocker] = useState<Blocker | null>(null);

  useEffect(() => {
    if (blocker.state === "blocked") {
      if (!shouldBlock) {
        blocker.proceed();
      } else {
        setLastBlocker(blocker);
        setShowModal(true);
      }
    }
  }, [blocker, shouldBlock]);

  const confirmLeave = () => {
    if (lastBlocker) lastBlocker.proceed();
    setShowModal(false);
    setLastBlocker(null);
  };

  const cancelLeave = () => {
    if (lastBlocker) lastBlocker.reset();
    setShowModal(false);
    setLastBlocker(null);
  };

  return { showModal, confirmLeave, cancelLeave };
};
